import {
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_VERIFIED_SUCCESS,
  USER_VERIFIED_FAILURE,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_FAILURE
} from '../actions/user';

export default function (state = {}, { type, payload }) {
  switch (type) {
    case USER_LOGOUT_SUCCESS:
      return {};
    case USER_LOGOUT_FAILURE:
      return state;
    case USER_VERIFIED_FAILURE:
      return {};
    case USER_VERIFIED_SUCCESS:
      return payload;
    case USER_LOGIN_SUCCESS:
      return payload
    case USER_LOGIN_FAILURE:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/user.js